/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostSdkKeyPathParams = NonNullable<operations['postSdkKey']['parameters']['path']>;

export type PostSdkKeyRequestBody = OperationRequestBodyContent<operations['postSdkKey']>;

export interface Input extends PostSdkKeyPathParams {
  apiVersion?: string;
  body: PostSdkKeyRequestBody;
  header: NonNullable<operations['postSdkKey']['parameters']['header']>;
}

export async function postSdkKey(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/environments/{environmentKey}/sdk-keys', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
